var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',[_c('SiteMasthead',{attrs:{"mini":"true","title":"Rental Appraisal"}}),_c('ContentRow',[_c('ContentContainer',[_c('SectionTitle',[_vm._v("Rental Appraisal")]),_c('Form',{attrs:{"type":"Generic.VideoAppraisalRequstFormTop"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }